import { Point2d } from "../../../../common/geometry/Geom2d";
import TabletopCanvasKeyEvent from "../events/TabletopCanvasKeyEvent";
import TabletopCanvasMouseEvent from "../events/TabletopCanvasMouseEvent";

import TabletopCanvasWheelEvent from "../events/TabletopCanvasWheelEvent";
import TabletopUniverse from "../../objects/TabletopUniverse";
import TabletopViewport from "../../objects/TabletopViewport";

export default abstract class TabletopCanvasController {
    protected _lastMousePosition: Point2d = { x: 0, y: 0 };
    protected _viewport: TabletopViewport;
    protected _universe: TabletopUniverse;

    public constructor(viewport: TabletopViewport, universe: TabletopUniverse) {
        this._viewport = viewport;
        this._universe = universe;
    }

    /** Occurs when the mouse cursor moves over the canvas. */
    public onCanvasMouseMove(e: TabletopCanvasMouseEvent): void {
        this._lastMousePosition = e.viewportPosition;
    }

    /** Occurs when the mouse cursor is moved while a mouse button is being held down after being pressed on the canvas. */
    public onCanvasMouseDrag(e: TabletopCanvasMouseEvent): void {}

    /** Occurs when a mouse button is pressed on the canvas. */
    public onCanvasMouseDown(e: TabletopCanvasMouseEvent): void {}

    /** Occurs when a mouse button is released on the canvas. */
    public onCanvasMouseUp(e: TabletopCanvasMouseEvent): void {}

    /** Occurs when the mouse wheel is scrolled over the canvas. */
    public onCanvasMouseWheel(e: TabletopCanvasWheelEvent): void {}

    /** Occurs when a key is pressed, and repeatedly if the key is held down. */
    public onCanvasKeyPress(e: TabletopCanvasKeyEvent): void {}

    /** Occurs when a key is first pressed down. */
    public onCanvasKeyDown(e: TabletopCanvasKeyEvent): void {}

    /** Occurs when a key release. */
    public onCanvasKeyUp(e: TabletopCanvasKeyEvent): void {}

    /** Cleans up any values being used by this controller. Should be called whenever a controller is being deleted. */
    public dispose(): void {}
}
